import { setupApi } from "~ui/utils/api"

export default setupApi({
  csrfEndpoint: "/admin/v1/auth/csrf",
  onRequest: ({ headers, isCsrfOnly }) => {
    const csrf = useCookie("XSRF-TOKEN")
    const { token, workspaceId, impersonatorId } = useAuth()

    if (!isCsrfOnly) {
      if (token.value) {
        headers.set("Authorization", `Bearer ${token.value}`)
      }
      if (workspaceId.value) {
        headers.set("X-Workspace", workspaceId.value)
      }
    }

    if (impersonatorId.value) {
      headers.set("X-Impersonator", impersonatorId.value)
    }

    if (csrf.value) {
      headers.set("X-XSRF-TOKEN", csrf.value)
    }
  },
  onResponseError: async ({ response, options }) => {
    if (response.status == 419) {
      return // csrf error, can be ignored
    }

    if (options.suppressedStatusCodes?.includes(response.status)) {
      return
    }

    if (response.status == 401 || response.status == 403) {
      await navigateTo({ name: "logout" })
      return
    }
  },
})
